<template lang="">
  <ProductDetailsHeader/>
  <div class="error-page">
    <div class="text-center">
      <img src="/images/error (2).gif" class="m-auto" />
      <h4 class="text-danger  text-center">Error!</h4>
      <p class="text-center">{{this.msg}}</p>
      <p class="text-center" v-if=this.journey_id>journey_id:{{this.journey_id}}</p>
      <p class="text-center" v-if=this.reqid>journey_id:{{this.reqid}}</p>
      <button
        class="erroButton"
        @click=goBack()
      >
        Go Back
      </button>
      <div></div>
    </div>
  </div>
</template>
<script>
import ProductDetailsHeader from '../productDetailsHeader/ProductDetailsHeader.vue';

export default {
  components:{
    ProductDetailsHeader
  },
  name: "error-page",
  data(){
    return{
      msg:"",
      msgError:"",
      backUrl:"",
      journey_id:"",
      reqid:""
    };
},
  mounted(){
    this.msg=this.$route.query.msg;
    this.backUrl=this.$route.query.backUrl
    this.reqid=this.$router.query?.reqid
    if(sessionStorage.getItem("journey_id")){
      this.journey_id=JSON.parse(sessionStorage.getItem("journey_id"))
    }

  },
  methods:{
    goBack()
    {
        if(this.backUrl=="New-Journey")
        this.$router.push({path: '/New-Journey'})
        else 
        this.$router.push({path: this.backUrl});

              
    }
  },

};
</script>
<style lang="scss">
@import "../../assets/scss/components/Loaders.scss";
</style>
